import { get, post, put } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const timezoneRequests = {};

const getAllSchedules = () => {
  return get(url.SCHEDULES + '?paused=false&reduceResponse=true')
    .then(response => {
      return response;
    })
    .catch(err => {
      throw err.response.data;
    });
};

const getAllSchedulesByDateAndBranch = (scheduleId, branchId, strDate) => {
    return get(url.SCHEDULES + '/' + scheduleId + '/branch/' + branchId + '/availability?strDate=' + encodeURIComponent(strDate))
    .then(response => {
      return response;
    })
    .catch(err => {
      throw err.response.data;
    });
};

const getAllBranches = () => {
  return get(url.BRANCHES)
    .then(response => {
      return response;
    })
    .catch(err => {
      throw err.response.data;
    });
};

const getAllDates = (scheduleId, branchId, strDate) => {
  return get(url.DATES + '?scheduleId=' + scheduleId + '&branchId=' + branchId + '&strDate=' + encodeURIComponent(strDate))
    .then(response => {
      return response;
    })
    .catch(err => {
      throw err.response.data;
    });
};

const getBranchTimezone = (branchId) => {
  if (!timezoneRequests[branchId]) {
    timezoneRequests[branchId] = get(url.TIMEZONE + '/' + branchId)
      .catch(err => {
        delete timezoneRequests[branchId];
        throw err.response.data;
      });
  }

  return timezoneRequests[branchId]
    .then(response => {
      return response;
    });
};

const insertAppointment = data => {
  return post(url.APPOINTMENTS, data)
    .then(response => {
      return response;
    })
    .catch(err => {
      throw err.response.data;
    });
};

export {
  getAllSchedules,
  getAllSchedulesByDateAndBranch,
  getAllBranches,
  getAllDates,
  getBranchTimezone,
  insertAppointment
};
